module.exports = __webpack_public_path__ + "img/3.dcb364a.png";